import { mergeGmPartCatalogIntoHome } from "@/gm/gm-part-catalog";
import { createDefaultHomeRoom, newHomeId, type HomeRoomData } from "@/home/storage";
import {
  TOWER_ARENA_COLS,
  TOWER_ARENA_ROWS,
  type TowerFloorConfig,
  type TowerFloorScenePlacement,
} from "@/tower/tower-floor-config";

/** Scene editor palette: dungeon/tower room + player's home upload library (by part id). */
export function mergeHomeCatalogParts(
  room: HomeRoomData,
  homeCatalog: HomeRoomData,
): HomeRoomData {
  const parts = [...room.parts];
  for (const part of homeCatalog.parts) {
    if (!parts.some((p) => p.id === part.id)) parts.push(part);
  }
  return { ...room, parts };
}

export function towerFloorToHomeRoom(config: TowerFloorConfig | null | undefined): HomeRoomData {
  const base = createDefaultHomeRoom();
  base.gridCols = TOWER_ARENA_COLS;
  base.gridRows = TOWER_ARENA_ROWS;
  const withCatalog = mergeGmPartCatalogIntoHome(base);
  const placements = (config?.scenePlacements ?? []).map((row) => ({
    id: newHomeId(),
    partId: row.partId,
    gridX: row.gridX,
    gridY: row.gridY,
  }));
  return { ...withCatalog, placements };
}

export function homeRoomToTowerScenePlacements(
  room: HomeRoomData,
): TowerFloorScenePlacement[] {
  return room.placements.map((p) => ({
    partId: p.partId,
    gridX: p.gridX,
    gridY: p.gridY,
    ...(p.depthBias !== undefined ? { depthBias: p.depthBias } : {}),
  }));
}

/** Scene room (editor) wins over saved floor config when placements exist. */
export function resolveDungeonFloorScenePlacements(
  room: HomeRoomData,
  configPlacements: TowerFloorScenePlacement[] | undefined,
): TowerFloorScenePlacement[] {
  const fromRoom = homeRoomToTowerScenePlacements(room);
  if (fromRoom.length > 0) return fromRoom;
  return configPlacements ?? [];
}
